<template>
  <div :class="{ 'inactive-page': !page.isAdmin }" style="cursor: pointer;">
    <v-avatar :size="60" color="grey lighten-4" style="border: 1px solid #eee">
      <img
        class="circle"
        :src="'https://graph.facebook.com/' + page.id + '/picture?width=100&height=100'"
        alt
      />
    </v-avatar>
    <div class="page-detail">
      <slot name="page-status"></slot>
      <p class="page-name text-truncate">{{ page.name }}</p>
      <span class="page-role">
        <template v-if="!page.isAdmin">{{ $t('No permission') }}</template>
        <template v-else>{{ role }}</template>
      </span>

      <slot name="install-button"></slot>
    </div>
    <slot name="select-page"></slot>
  </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    page: function() {
      let vm = this
      let page = this.value
      page.isAdmin = false

      if (page.perms) {
        $.each(page.perms, function(index, val) {
          if (val == 'ADMINISTER') {
            vm.role = vm.$t('Administer')
            page.isAdmin = true
            return false
          }
        })
      }
      if (page.tasks) {
        $.each(page.tasks, function(index, val) {
          if (val == 'MANAGE') {
            vm.role = vm.$t('Administer')
            page.isAdmin = true
            return false
          }
        })
      }
      return page
    }
  },
  data: function() {
    return {
      role: ''
    }
  },
  methods: {
    onPageClick: function() {
      if (this.page.isAdmin) {
        this.$emit('onPageClick', this.page)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inactive-page {
  opacity: 0.4 !important;
  background: #eee !important;
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/allbots/PageItem.vue